// 给列表页图片拼上参数
export default function updateImageListSrc(value, type) {
    if (value === undefined || value === null || value === '') {
        return value
    }
    
    // 检查是否为GIF图片（不区分大小写）
    const isGif = /\.gif($|\?)/i.test(value);
    if (isGif) {
        return value; // GIF图片不添加任何参数
    }
    
    // 检查是否为预签名URL（包含OSS关键参数）
    if (value.includes('Expires') && value.includes('OSSAccessKeyId') && value.includes('Signature')) {
        return value;
    }

    // 使用对象映射定义处理参数
    const processParamsMap = {
        1: 'x-oss-process=image/resize,m_fill,w_1080,limit_0/format,webp',  // 1帖子封面图
        2: 'x-oss-process=image/resize,m_fill,w_400,h_400,limit_0/format,webp',   // 2为九宫格图片
        3: 'x-oss-process=image/resize,m_fill,w_1080,h_375,limit_0/format,webp', // 3为首页banner图片
        4: 'x-oss-process=image/resize,m_fill,w_600,limit_0/format,webp', // 4为两列图片(酷币商城列表)
        5: 'x-oss-process=image/resize,m_fill,w_600,limit_0/format,webp', // 5为一列图片
        6: 'x-oss-process=image/resize,m_fill,w_1080,h_246,limit_0/format,webp', // 6为酷币商城banner图片
        7: 'x-oss-process=image/resize,m_lfit,w_1080/format,webp', // 7为酷币商城详情图片
        8: 'x-oss-process=image/resize,m_lfit,w_600,limit_0/format,webp', // 8为推荐关注页图片
        9: 'x-oss-process=image/format,webp', // 9为评论列表图片
        10: 'x-oss-process=image/resize,m_lfit,w_1280,h_16384/format,webp', // 10为瀑布流详情页图片
        11: 'x-oss-process=image/resize,m_lfit,w_600/format,webp', // 11为瀑布流列表页图片
        12: 'x-oss-process=image/resize,m_lfit,w_1080,h_16384/format,webp', // 评论列表图片参数
        13: 'x-oss-process=image/resize,m_lfit,w_1080,h_540,limit_0/format,webp', // 评论列表图片参数
        14: 'x-oss-process=image/resize,m_fill,w_400,h_600,limit_0/format,webp', // 评论列表图片参数
        15: 'x-oss-process=image/resize,m_fill,w_500,limit_0/format,webp',  // 新品众测列表页图片参数
        16: 'x-oss-process=image/resize,m_lfit,w_1080,limit_0/format,webp', // 嘉年华图片参数
        17: 'x-oss-process=image/resize,m_fill,w_400,limit_0/format,webp', // 帖子列表页图片1:1图片规则
        18: 'x-oss-process=image/resize,m_fill,w_400,h_600,limit_0/format,webp', // 帖子列表页图片2:2.95或者2:3图片规则
        19: 'x-oss-process=image/resize,m_fill,w_1080,h_540,limit_0/format,webp', // 帖子列表页图片2:1图片规则
        20: 'x-oss-process=image/resize,m_lfit,w_1080,h_16384/format,webp', // 抽奖活动封面、个人主页背景图
        21: 'x-oss-process=image/resize,m_fill,w_180,limit_0/format,webp', // 抽奖奖品图片
        22: 'x-oss-process=image/resize,m_pad,w_1080,h_540,color_121212,limit_0/format,webp', // 帖子列表页2:1 横版视频，默认第一帧作为封面图片规则
        23: 'x-oss-process=image/resize,m_pad,w_400,h_600,color_121212,limit_0/format,webp', // 帖子列表页2:2.95或2:3 竖版视频，默认第一帧作为封面图片规则
        24: 'x-oss-process=image/resize,m_fill,w_1080,h_277,limit_0/format,webp', // 3为首页banner图片和活动列表图片
        
    };

    // 获取处理参数，如果没有匹配则使用默认值
    const processParams = processParamsMap[type] || processParamsMap[2]; // 默认使用type=2的参数

    // 检查URL是否已有查询参数
    const separator = value.includes('?') ? '&' : '?';
    // 返回处理后的URL
    return `${value}${separator}${processParams}`;
}
